// Fonte única dos níveis de raciocínio (thinking levels).
// Tokens são o que o backend traduz para o parâmetro nativo de cada provedor.

export const REASONING_LABEL: Record<string, string> = {
  off: "Desligado",
  minimal: "Mínimo",
  low: "Baixo",
  medium: "Médio",
  high: "Alto",
  xhigh: "Muito alto",
  max: "Máximo",
};

// Níveis selecionáveis por provedor (para o catálogo no Painel Dev).
// "off" sempre incluído (modelo sem raciocínio = só "Desligado").
export const PROVIDER_REASONING_LEVELS: Record<string, string[]> = {
  // "off" vira reasoning.effort="none" na chamada. "minimal" só existe até o
  // gpt-5.1 — o gpt-5.6 recusa; marcar por modelo o que cada um aceita.
  openai: ["off", "minimal", "low", "medium", "high", "xhigh", "max"],
  // "off" não manda effort → padrão da Anthropic pro modelo (Haiku 5.5: medium).
  anthropic: ["off", "low", "medium", "high", "xhigh", "max"],
  google: ["off", "minimal", "low", "medium", "high"],
  grok: ["off", "low", "medium", "high"],
  openrouter: ["off", "low", "medium", "high"],
  // DeepSeek V4: thinking on/off via parâmetro. "off" → disabled; low/high/max →
  // enabled + reasoning_effort (valores aceitos pela doc de thinking mode).
  deepseek: ["off", "low", "high", "max"],
  // Muse Spark raciocina sempre: reasoning_effort="none" devolve 400. Sem "off".
  meta: ["minimal", "low", "medium", "high", "xhigh"],
};

export function reasoningLabel(token: string): string {
  return REASONING_LABEL[token] ?? token;
}
